// src/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';

export default function PrivateRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <p style={{ color: 'white', textAlign: 'center' }}>Chargement...</p>;
  if (!user) return <Navigate to="/auth" replace />;

  return children;
}
